import axiosInstance from "./AxiosInstance";

export function getDefaultDoses(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("default-dose/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function createDefaultDose(defaultDoseData) {
  return axiosInstance.post("default-dose/add", defaultDoseData);
}

export function updateDefaultDose(defaultDoseData) {
  return axiosInstance.post("default-dose/edit", {
    ...defaultDoseData,
  });
}

export function deleteDefaultDose(defaultDoseId) {
  return axiosInstance.post("default-dose/delete", {
    dose_id: defaultDoseId,
  });
}

export function formatDefaultDoses(data = []) {
  return data.map((dose) => ({
    id: dose.dose_id,
    dose_text: dose.dose_text,
    dose_status: dose.dose_status,
    created_at: dose.created_at,
    updated_at: dose.updated_at,
  }));
}

